// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.learning-courselist {
    max-width: 1020px;
}

.learning-courselist-item {
    border-bottom: 1px solid var(--colorDivider);
    padding: 16px 0px;
}

.learning-courselist-item-mobile {
    border-bottom: 1px solid var(--colorDivider);
    margin: 8px 0 !important;
    max-width: 80vw;
}

.learning-courselist-item-image {
    width: 118px !important;
    height: 66px !important;
    overflow: hidden;
    margin-right: 8px !important;
}

.learning-courselist-info {
    max-width: 800px;
}

.learning-courselist-item-mobile div.MuiChip-root {
    max-width: 40vw;
}`, "",{"version":3,"sources":["webpack://./../../../Components/Module/LearningActivityItem/style.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,4CAA4C;IAC5C,iBAAiB;AACrB;;AAEA;IACI,4CAA4C;IAC5C,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".learning-courselist {\r\n    max-width: 1020px;\r\n}\r\n\r\n.learning-courselist-item {\r\n    border-bottom: 1px solid var(--colorDivider);\r\n    padding: 16px 0px;\r\n}\r\n\r\n.learning-courselist-item-mobile {\r\n    border-bottom: 1px solid var(--colorDivider);\r\n    margin: 8px 0 !important;\r\n    max-width: 80vw;\r\n}\r\n\r\n.learning-courselist-item-image {\r\n    width: 118px !important;\r\n    height: 66px !important;\r\n    overflow: hidden;\r\n    margin-right: 8px !important;\r\n}\r\n\r\n.learning-courselist-info {\r\n    max-width: 800px;\r\n}\r\n\r\n.learning-courselist-item-mobile div.MuiChip-root {\r\n    max-width: 40vw;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
